var InFlight = InFlight || {};
(function () {
  function _isLoggedInResultPage() {
    // checking document.referrer to not return true if the user goes directly to a url with login=true
    return document.referrer && window.ifReferenceWindow.location.search.indexOf('login=true') >= 0;
  }

  InFlight.User = (function () {
    var _states = {
      ENTITY_TYPE_BIDDER: 'Bidder',
      ENTITY_TYPE_SUPPLIER: 'Supplier',
      ACCOUNT_TYPE_BIDDER: 'Bidder',
      ACCOUNT_TYPE_UNAPPROVED_SUPPLIER: 'Unapproved Supplier',
      ACCOUNT_TYPE_SUBCONTRACTOR: 'Subcontractor',
      ACCOUNT_TYPE_BLOCKED: 'Blocked Account',
      ACCOUNT_TYPE_APPROVED_SUPPLIER: 'Approved Supplier',
      ACCOUNT_TYPE_SUPPLIER_ISSUES: 'Supplier Issues',
      ACCOUNT_TYPE_INACTIVE: 'Inactive Account',
      SUPPLIER_STATE_NONE: '',
      SUPPLIER_STATE_UNAPPROVED: 'Unapproved',
      SUPPLIER_STATE_APPROVED: 'Approved',
      GOV_CLASS_NONE: '',
      GOV_CLASS_TAX: 'TAX',
      GOV_CLASS_EX: 'EX',
      GOV_CLASS_DND: 'DND',
      GOV_CLASS_DLQ: 'DLQ',
      SUPPLIER_EXPIRATION_STATUS_INCOMPLETE: 'Incomplete',
      SUPPLIER_EXPIRATION_STATUS_GOOD: 'Good',
      SUPPLIER_EXPIRATION_STATUS_IMMINENT: 'Imminent',
      SUPPLIER_EXPIRATION_STATUS_IMMINENT_ASAP: 'Imminent - ASAP',
      SUPPLIER_EXPIRATION_STATUS_EXPIRED: 'Expired',
      COMPLIANCE_STATUS_NONE: '',
      COMPLIANCE_STATUS_PENDING: 'Pending',
      COMPLIANCE_STATUS_DENIED: 'Denied',
      COMPLIANCE_STATUS_CONTRACT: 'Contract by Contract',
      COMPLIANCE_STATUS_COMPLIANT: 'Equal Benefits Compliant',
      VENDOR_CLASS_SUBCONTRACTOR: 'S',
      VENDOR_CLASS_ATTORNEY: 'A',
      VENDOR_CLASS_EMPLOYEE: 'E',
      VENDOR_CLASS_HCM: 'H',
      VENDOR_CLASS_OUTSIDE_PARTY: 'R',
      VENDOR_CLASS_PAYMENT: 'P',
      VENDOR_CLASS_NONE: '',
      VENDOR_STATUS_PO_YES: 'Y',
      VENDOR_STATUS_PO_NO: 'N',
      VENDOR_STATUS_PO_NONE: ''
    };

    var userInfoPromise;

    function getPropData(data, name, content) {
      return InFlight.NLX.Utils.props(data, name)[content];
    }

    function getChildrenPropData(data, name, content) {
      if (data[name]) {
        try {
          var obj = data[name][0];
          return obj.Properties[content];
        } catch (e) {
          return null;
        }
      }
    }

    function trimString(str) {
      if (str) {
        return str.trim();
      }
      return str;
    }

    //there is a bug where if the user logs in and immediately logs out, then logs back in
    //as a different user then Modern authenticates as the previous user. If the inital user does 
    //anything that hits a peoplesoft page then the issue does not happen. So on logout we 
    //hit event-search (available to all users) and then do the logout procedure there.
    function doLogout() {
      InFlight.Utils.goTo('/pages/logout.aspx');
    }

    function isLoggedIn() {
      return !!currentUser() || _isLoggedInResultPage();
    }

    function _clearSession() {
      return InFlight.Utils.get('/inflight/clearsession');
    }

    function _doLogout(cb) {
      _clearSession().then(function () {
        //TODO:  do logout server calls
        sessionStorage.clear();
        setPageHeader();

        if (cb) {
          cb();
        } else {
          InFlight.Utils.goTo('/pages/index.aspx');
        }
      });
    }

    function doLogin(clientParam) {
      var loginUrl = InFlight.NLX.Cfg.Customer.psLoginUrl();
      if (clientParam) {
     /*   loginUrl = loginUrl.replace(
          '/IFRedirect/',
          '/IFRedirect/' + clientParam + '/'
        );*/
        if(loginUrl.indexOf('?')>-1) {
          loginUrl=loginUrl + "&IFRedirect=true"
        } else {
          loginUrl=loginUrl + "?IFRedirect=true"
        }

      }

      if (InFlight.NLX.Cfg.Customer.useDirectLogin) {
        InFlight.Utils.goTo(loginUrl);
        return;
      }
      // Hitting unauthenticated page first to retrieve necessary cookies
      var myconfig = {
        targetUrl: InFlight.NLX.Cfg.Customer.psRootUrl() + '/h/?tab=DEFAULT',
        targetVerb: 'GET',
        followProposedTemplate: false,
        callback: function (data) {
          if (data && data.CaptureResults) {
            InFlight.Utils.goTo(loginUrl);
          }
        }
      };
      var InFlightDC = new InFlightDCType(false);
      InFlightDC.init(myconfig);
    }

    function psBaseUrl() {
      return InFlight.User.isLoggedIn()
        ? InFlight.NLX.Cfg.Customer.psAuthBaseUrl()
        : InFlight.NLX.Cfg.Customer.psBaseUrl();
    }

    function clearLogin(cb) {
      _clearSession().then(function () {
        sessionStorage.removeItem('User');
        setPageHeader();
        if (cb) {
          cb();
        }
      });
    }

    function _makeUserInfoRequest(callback) {
      var myconfig = {
        targetUrl: InFlight.NLX.Cfg.Customer.psAuthBaseUrl() + '/q/?ICAction=ICQryNameURL=PUBLIC.FSP_INFLIGHT_VENDOR_STATUS',
        targetVerb: 'GET',
        followProposedTemplate: false,
        manualRequestObj: [
          {
            Lbl: 'Company',
            Src: 'table.PSQRYTABLELEFTBORDER tr:not(":nth-child(1)")',
            Children: [
              {
                Lbl: 'AccountID',
                Src: 'td:eq(1)',
                Data: 'text'
              },
              {
                Lbl: 'EntityName',
                Src: 'td:eq(2)',
                Data: 'text'
              },
              {
                Lbl: 'EntityType',
                Src: 'td:eq(3)',
                Data: 'text'
              },
              {
                Lbl: 'ModifiedDate',
                Src: 'td:eq(4)',
                Data: 'text'
              },
              {
                Lbl: 'SupplierStatus',
                Src: 'td:eq(5)',
                Data: 'text'
              },
              {
                Lbl: 'GovClass',
                Src: 'td:eq(6)',
                Data: 'text'
              },
              {
                Lbl: 'TaxCertExpireDate',
                Src: 'td:eq(7)',
                Data: 'text'
              },
              {
                Lbl: 'ComplianceStatus',
                Src: 'td:eq(8)',
                Data: 'text'
              },
              {
                Lbl: 'UserName',
                Src: 'td:eq(9)',
                Data: 'text'
              },
              {
                Lbl: 'HQState',
                Src: 'td:eq(10)',
                Data: 'text'
              },
              {
                Lbl: 'VendorClass',
                Src: 'td:eq(11)',
                Data: 'text'
              },
              {
                Lbl: 'VendorPoStatus',
                Src: 'td:eq(12)',
                Data: 'text'
              },
              {
                Lbl: 'SfSuspended',
                Src: 'td:eq(13)',
                Data: 'text'
              },
              {
                Lbl: 'SusEffective',
                Src: 'td:eq(14)',
                Data: 'text'
              },
              {
                Lbl: 'SusExpires',
                Src: 'td:eq(15)',
                Data: 'text'
              },
              {
                Lbl: 'SfDebarred',
                Src: 'td:eq(16)',
                Data: 'text'
              },
              {
                Lbl: 'DebExpires',
                Src: 'td:eq(17)',
                Data: 'text'
              },
              {
                Lbl: 'DebExpires',
                Src: 'td:eq(18)',
                Data: 'text'
              },
              {
                Lbl: 'BusStruct',
                Src: 'td:eq(19)',
                Data: 'text'
              },
              {
                Lbl: 'DiversityExists',
                Src: 'td:eq(20)',
                Data: 'text'
              }
            ]
          }
        ],
        callback: function (data) {
          var userData = [];
          if (data && data.CaptureResults && data.CaptureResults.Company) {
            var companies = data.CaptureResults.Company;
            var companyCount = companies.length;

            for (var i = 0; i < companyCount; i++) {
              var userCompanyInfo = getUserCompanyInfo(companies[i].Children);
              userData.push(userCompanyInfo);
            }

            sessionStorage.setItem('UserInfo', JSON.stringify(userData));
            if (callback) {
              callback(userData);
            }
          } else {
            //if no rows the user is an inactive supplier
            var userInfo = {
              accountType: _states.ACCOUNT_TYPE_INACTIVE,
              userName: _states.ACCOUNT_TYPE_INACTIVE,
              type: _states.ENTITY_TYPE_SUPPLIER
            };
            userData.push(userInfo);
            sessionStorage.setItem('UserInfo', JSON.stringify(userData));
            if (callback) {
              callback(userData);
            }
          }
        }
      };
      var InFlightDC = new InFlightDCType(false);
      InFlightDC.init(myconfig);
    }

    function extractUser(userInfo) {
      if (userInfo && userInfo.length) {
        var oneUser = true;
        var firstUserName = userInfo[0].userName;
        for (var i = 0; i < userInfo.length; i++) {
          if (userInfo[i].userName !== firstUserName) {
            oneUser = false;
          }
        }

        if (oneUser) {
          sessionStorage.User = firstUserName;
        }
        else {
          sessionStorage.removeItem('User');
        }
      }
    }

    function lookUpState(stateAbbr) {
      if (!stateAbbr) {
        return '';
      }

      var array =
        [
          { key: "AK", value: "Alaska" },
          { key: "AL", value: "Alabama" },
          { key: "AR", value: "Arkansas" },
          { key: "AS", value: "American Samoa" },
          { key: "AZ", value: "Arizona" },
          { key: "CA", value: "California" },
          { key: "CO", value: "Colorado" },
          { key: "CT", value: "Connecticut" },
          { key: "DC", value: "District of Columbia" },
          { key: "DE", value: "Delaware" },
          { key: "FL", value: "Florida" },
          { key: "GA", value: "Georgia" },
          { key: "GU", value: "Guam" },
          { key: "HI", value: "Hawaii" },
          { key: "IA", value: "Iowa" },
          { key: "ID", value: "Idaho" },
          { key: "IL", value: "Illinois" },
          { key: "IN", value: "Indiana" },
          { key: "KS", value: "Kansas" },
          { key: "KY", value: "Kentucky" },
          { key: "LA", value: "Louisiana" },
          { key: "MA", value: "Massachusetts" },
          { key: "MD", value: "Maryland" },
          { key: "ME", value: "Maine" },
          { key: "MI", value: "Michigan" },
          { key: "MN", value: "Minnesota" },
          { key: "MO", value: "Missouri" },
          { key: "MP", value: "Northern Mariana Islands" },
          { key: "MS", value: "Mississipi" },
          { key: "MT", value: "Montana" },
          { key: "NC", value: "North Carolina" },
          { key: "ND", value: "North Dakota" },
          { key: "NE", value: "Nebraska" },
          { key: "NH", value: "New Hampshire" },
          { key: "NJ", value: "New Jersey" },
          { key: "NM", value: "New Mexico" },
          { key: "NV", value: "Nevada" },
          { key: "NY", value: "New York" },
          { key: "OH", value: "Ohio" },
          { key: "OK", value: "Oklahoma" },
          { key: "OR", value: "Oregon" },
          { key: "PA", value: "Pennsylvania" },
          { key: "PR", value: "Puerto Rico" },
          { key: "RI", value: "Rhode Island" },
          { key: "SC", value: "South Carolina" },
          { key: "SD", value: "South Dakota" },
          { key: "TN", value: "Tennessee" },
          { key: "TX", value: "Texas" },
          { key: "UM", value: "US - Minor Outlaying Islands" },
          { key: "UT", value: "Utah" },
          { key: "VA", value: "Virgina" },
          { key: "VI", value: "Virgin Islands" },
          { key: "VT", value: "Vermont" },
          { key: "WA", value: "Washington" },
          { key: "WI", value: "Wisconsin" },
          { key: "WV", value: "West Virginia" },
          { key: "WY", value: "Wyoming" },
          { key: "INTERNATIONAL", value: "INTERNATIONAL" }
        ];

      for (var i = 0; i < array.length; i++) {
        if (array[i].key === stateAbbr) {
          return array[i].value;
        }
      }

      return stateAbbr;
    }

    function getUserInfo() {
      if (userInfoPromise) {
        return userInfoPromise;
      } else {
        userInfoPromise = new Promise(function (resolve, reject) {
          var userInfo = sessionStorage.getItem('UserInfo');
          if (userInfo) {
            const userInfoObj = JSON.parse(userInfo)
            extractUser(userInfoObj);
            resolve(userInfoObj);
          } else {
            _makeUserInfoRequest(function (userInfo) {
              extractUser(userInfo);
              resolve(userInfo);
            });
          }
        });
        return userInfoPromise;
      }
    }

    function getUserCompanyInfo(data) {
      var userInfo = {
        accountID: getChildrenPropData(data, 'AccountID', 'text'),
        company: getChildrenPropData(data, 'EntityName', 'text'),
        type: getChildrenPropData(data, 'EntityType', 'text'),
        modifiedDate: getChildrenPropData(data, 'ModifiedDate', 'text'),
        supplierStatus: trimString(
          getChildrenPropData(data, 'SupplierStatus', 'text')
        ),
        govClass: trimString(getChildrenPropData(data, 'GovClass', 'text')),
        taxExpirationDate: trimString(
          getChildrenPropData(data, 'TaxCertExpireDate', 'text')
        ),
        complianceStatus: trimString(
          getChildrenPropData(data, 'ComplianceStatus', 'text')
        ),
        userName: trimString(
          getChildrenPropData(data, 'UserName', 'text')
        ),
        hqState: lookUpState(trimString(
          getChildrenPropData(data, 'HQState', 'text')
        )),
        vendorClass: trimString(
          getChildrenPropData(data, 'VendorClass', 'text')
        ),
        vendorPoStatus: trimString(
          getChildrenPropData(data, 'VendorPoStatus', 'text')
        ),
        sfSuspended: trimString(
          getChildrenPropData(data, 'SfSuspended', 'text')
        ),
        susEffective: trimString(
          getChildrenPropData(data, 'SusEffective', 'text')
        ),
        susExpires: trimString(
          getChildrenPropData(data, 'SusExpires', 'text')
        ),
        sfDebarred: trimString(
          getChildrenPropData(data, 'SfDebarred', 'text')
        ),
        debExpires: trimString(
          getChildrenPropData(data, 'DebExpires', 'text')
        ),
        debExpires: trimString(
          getChildrenPropData(data, 'DebExpires', 'text')
        ),
        busStruct: trimString(
          getChildrenPropData(data, 'BusStruct', 'text')
        ),
        diversityExists: trimString(
          getChildrenPropData(data, 'DiversityExists', 'text')
        ),
      };

      // create and check expiration status
      var today = Date.today();
      if (userInfo.type === _states.ENTITY_TYPE_SUPPLIER) {
        var expiration = Date.parse(userInfo.taxExpirationDate);
        userInfo.supplierExpirationStatus = _states.SUPPLIER_EXPIRATION_STATUS_INCOMPLETE;

        if (expiration) {
          userInfo.supplierExpirationStatus = _states.SUPPLIER_EXPIRATION_STATUS_GOOD;
          if (Date.compare(today, expiration) === 1) {
            userInfo.supplierExpirationStatus = _states.SUPPLIER_EXPIRATION_STATUS_EXPIRED;
          } else if (Date.compare(expiration, today.add({ days: 30 })) <= 0 ){
            userInfo.supplierExpirationStatus = _states.SUPPLIER_EXPIRATION_STATUS_IMMINENT_ASAP;
          } else if (Date.compare(expiration, today.add({ days: 45 })) <= 0) {
            userInfo.supplierExpirationStatus = _states.SUPPLIER_EXPIRATION_STATUS_IMMINENT;
          } 
        }
      }

      // create account type
      userInfo.accountType = _states.ACCOUNT_TYPE_BIDDER; // by default users are bidders
      if(userInfo.supplierStatus === _states.SUPPLIER_STATE_UNAPPROVED) {
        userInfo.accountType = _states.ACCOUNT_TYPE_UNAPPROVED_SUPPLIER;
      } else if (userInfo.vendorClass === _states.VENDOR_CLASS_SUBCONTRACTOR) {
        userInfo.accountType = _states.ACCOUNT_TYPE_SUBCONTRACTOR;
      } else if (userInfo.vendorPoStatus === _states.VENDOR_STATUS_PO_NO) {
        userInfo.accountType = _states.ACCOUNT_TYPE_BLOCKED;
      } else if (
        userInfo.type === _states.ENTITY_TYPE_SUPPLIER &&
        (userInfo.govClass === _states.GOV_CLASS_DLQ ||
          userInfo.govClass === _states.GOV_CLASS_NONE) &&
        (userInfo.supplierExpirationStatus ===
          _states.SUPPLIER_EXPIRATION_STATUS_EXPIRED ||
          userInfo.complianceStatus === _states.COMPLIANCE_STATUS_PENDING ||
          userInfo.complianceStatus === _states.COMPLIANCE_STATUS_CONTRACT ||
          userInfo.complianceStatus === _states.COMPLIANCE_STATUS_DENIED)
      ) {
        userInfo.accountType = _states.ACCOUNT_TYPE_SUPPLIER_ISSUES;
      } else if (
        userInfo.vendorPoStatus === _states.VENDOR_STATUS_PO_YES &&
        userInfo.supplierStatus === _states.SUPPLIER_STATE_APPROVED &&
        (userInfo.govClass === _states.GOV_CLASS_TAX ||
          userInfo.govClass === _states.GOV_CLASS_EX) &&
        userInfo.supplierExpirationStatus ===
        _states.SUPPLIER_EXPIRATION_STATUS_GOOD &&
        (userInfo.complianceStatus === _states.COMPLIANCE_STATUS_COMPLIANT ||
          userInfo.complianceStatus === _states.COMPLIANCE_STATUS_CONTRACT)
      ) {
        userInfo.accountType = _states.ACCOUNT_TYPE_APPROVED_SUPPLIER;
      } else if (
        userInfo.vendorPoStatus === _states.VENDOR_STATUS_PO_YES &&
        userInfo.supplierStatus === _states.SUPPLIER_STATE_APPROVED &&
        userInfo.govClass === _states.GOV_CLASS_DND &&
        (userInfo.complianceStatus === _states.COMPLIANCE_STATUS_COMPLIANT ||
          userInfo.complianceStatus === _states.COMPLIANCE_STATUS_CONTRACT)
      ) {
        userInfo.accountType = _states.ACCOUNT_TYPE_APPROVED_SUPPLIER;
      } else if (
        userInfo.vendorPoStatus === _states.VENDOR_STATUS_PO_YES &&
        (userInfo.supplierStatus === _states.SUPPLIER_STATE_UNAPPROVED ||
          userInfo.type === _states.ENTITY_TYPE_SUPPLIER)
      ) {
        userInfo.accountType = _states.ACCOUNT_TYPE_SUPPLIER_ISSUES;
      } else if (
        userInfo.supplierStatus === _states.SUPPLIER_STATE_NONE &&
        userInfo.vendorClass === _states.VENDOR_CLASS_NONE &&
        userInfo.vendorPoStatus === _states.VENDOR_STATUS_PO_NONE &&
        userInfo.complianceStatus === _states.COMPLIANCE_STATUS_NONE &&
        userInfo.type === _states.ENTITY_TYPE_SUPPLIER
      ) {
        userInfo.accountType = _states.ACCOUNT_TYPE_INACTIVE
      }

      return userInfo;
    }

    function currentUser() {
      return sessionStorage.User;
    }

    return {
      doLogin: doLogin,
      doLogout: doLogout,
      isLoggedIn: isLoggedIn,
      psBaseUrl: psBaseUrl,
      clearLogin: clearLogin,
      States: _states,
      getUserInfo: getUserInfo,
      currentUser: currentUser
    };
  })();

  $(function () {
    if (InFlight.User.isLoggedIn()) {
      if (_isLoggedInResultPage()) {
        // then just logged in
        InFlight.GTM.login();
      }
    } else {
      sessionStorage.removeItem('User');
      sessionStorage.removeItem('UserInfo');
    }
    setPageHeader();
  });
})();
